import { collectPages } from '../shared/collectPages';
import type { ByCursorOptions, SdkItems } from '../types';
import { iterateByCursor } from './iterateByCursor';

// gloss
export const fetchAllByCursor = <R, T = SdkItems<R>>(options: ByCursorOptions<R>): Promise<T[]> =>
  collectPages<T, ByCursorOptions<R>>(iterateByCursor<R, T>, options);
